<template>
  <TextInput
    :label="label"
    :model-value="value"
    :error="errorMsg"
    :placeholder="label"
    @blur="validation.$touch()"
    @update:model-value="$emit('input', $event)"
  />
</template>

<script setup lang="ts">
import { TextInput } from '@ramp106/omrjs-core-ui/deprecated'
import type { BaseValidation } from '@vuelidate/core'
import { computed } from 'vue'

interface FormInputFieldEmits {
  (e: 'input', value: string): void
}

interface FormInputFieldProps {
  validation: BaseValidation
  value?: string
  label: string
}

defineEmits<FormInputFieldEmits>()

const props = defineProps<FormInputFieldProps>()

const errorMsg = computed(() => props.validation.$errors.map((error) => error.$message).join(', '))
</script>
